var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "ma-0 pa-0", attrs: { fluid: "" } },
    [
      [
        _c(
          "v-toolbar",
          { attrs: { color: "fill" } },
          [
            _c(
              "v-col",
              { staticClass: "mr-auto pl-0", attrs: { cols: "auto" } },
              [
                _c(
                  "router-link",
                  {
                    staticClass: "primary--text",
                    staticStyle: { "text-decoration": "none" },
                    attrs: { to: { path: "/promos" } }
                  },
                  [
                    _c("v-icon", { attrs: { color: "primary" } }, [
                      _vm._v("mdi-chevron-left")
                    ]),
                    _vm._v("Return to Promotions ")
                  ],
                  1
                )
              ],
              1
            ),
            _vm.tab !== 0
              ? _c("v-col", [
                  _c(
                    "span",
                    [
                      _c("span", { staticClass: "text-caption py-0" }, [
                        _c("b", [_vm._v("Promo Name:")]),
                        _vm._v(" " + _vm._s(_vm.promo.name) + " ")
                      ]),
                      _c(
                        "v-icon",
                        {
                          staticClass: "display-dot",
                          attrs: { color: "#000", "aria-hidden": "true" }
                        },
                        [_vm._v("mdi-circle-small")]
                      ),
                      _c("span", { staticClass: "text-caption py-0" }, [
                        _c("b", [_vm._v("Promotion Number:")]),
                        _vm._v(" " + _vm._s(_vm.promo.promo_number) + " ")
                      ]),
                      _c(
                        "v-icon",
                        {
                          staticClass: "display-dot",
                          attrs: { color: "#000", "aria-hidden": "true" }
                        },
                        [_vm._v("mdi-circle-small")]
                      ),
                      _c("span", { staticClass: "text-caption py-0" }, [
                        _c("b", [_vm._v("Promo Category:")]),
                        _vm._v(" " + _vm._s(_vm.promoTypeDisplayName) + " ")
                      ]),
                      _c(
                        "v-icon",
                        {
                          staticClass: "display-dot",
                          attrs: { color: "#000", "aria-hidden": "true" }
                        },
                        [_vm._v("mdi-circle-small")]
                      ),
                      _vm.promo.status
                        ? _c("span", { staticClass: "text-caption py-0" }, [
                            _c("b", [_vm._v("Status:")]),
                            _vm._v(
                              " " + _vm._s(_vm.promo.status.status.name) + " "
                            )
                          ])
                        : _vm._e(),
                      _vm.promo.cloned_from_promo_id
                        ? [
                            _c("v-icon", { attrs: { color: "#000" } }, [
                              _vm._v("mdi-circle-small")
                            ]),
                            _c(
                              "span",
                              { staticClass: "text-caption py-0" },
                              [
                                _c(
                                  "router-link",
                                  {
                                    staticClass: "primary--text",
                                    staticStyle: { "text-decoration": "none" },
                                    attrs: {
                                      to: {
                                        name: "Promo",
                                        query: {
                                          id: _vm.promo.cloned_from_promo_id
                                        }
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(" Parent "),
                                    _c(
                                      "v-icon",
                                      {
                                        attrs: { small: "", color: "primary" }
                                      },
                                      [_vm._v("mdi-launch")]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ]
                        : _vm._e()
                    ],
                    2
                  )
                ])
              : _vm._e(),
            _c(
              "span",
              { staticClass: "ml-auto" },
              [
                _c("PromoActions", {
                  attrs: {
                    value: _vm.tab,
                    id: _vm.id,
                    readOnlyPromo: _vm.readOnlyPromo,
                    showContractDownloadButton: _vm.showContractDownloadButton,
                    isPromoStatusAdmin: _vm.isPromoStatusAdmin,
                    showVendorApproval: _vm.showVendorApproval,
                    isPromoVendorAdmin: _vm.isPromoVendorAdmin,
                    showShuttleButton: _vm.showShuttleButton,
                    showComplexMerging: _vm.showComplexMerging,
                    showMergedPromos: _vm.showMergedPromos,
                    itemsDisabled: _vm.itemsDisabled,
                    promoNameEditException: _vm.promoNameEditException,
                    enabledInApprovedStatus: _vm.enabledInApprovedStatus,
                    promo: _vm.promo,
                    saving: _vm.saving
                  },
                  on: {
                    openCloneModal: function($event) {
                      _vm.showCloneModal = true
                    },
                    openStatusModal: function($event) {
                      _vm.showStatusModal = true
                    },
                    openShuttleModal: function($event) {
                      _vm.showShuttleModal = true
                    },
                    openVendorApprovalModal: function($event) {
                      _vm.vendorApprovalModal = true
                    },
                    openConfirmationModal: function($event) {
                      _vm.confirmationModal = true
                    },
                    openComplexMergingModal: function($event) {
                      _vm.complexMergingModal = true
                    },
                    openMergedPromosModal: function($event) {
                      _vm.mergedPromosModal = true
                    },
                    downloadContract: _vm.downloadContract,
                    downloadPromo: _vm.download,
                    savePromo: _vm.savePromo
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        _c(
          "v-tabs",
          {
            attrs: {
              grow: "",
              dark: "",
              "background-color": "primary",
              "hide-slider": "",
              "active-class": "active"
            },
            model: {
              value: _vm.tab,
              callback: function($$v) {
                _vm.tab = $$v
              },
              expression: "tab"
            }
          },
          [
            _c("v-tab", [_vm._v("Promotion Details")]),
            _c("v-tab", { attrs: { disabled: !_vm.existingPromo } }, [
              _vm._v("Group / Store")
            ]),
            _c(
              "v-tab",
              { attrs: { disabled: !_vm.existingPromo || _vm.itemsDisabled } },
              [_vm._v("Items")]
            )
          ],
          1
        ),
        _c(
          "keep-alive",
          [
            _vm.tab === 0
              ? _c("span", [
                  _c(
                    "div",
                    { staticClass: "mx-8 mt-8" },
                    [
                      _vm.isInFlight
                        ? _c(
                            "v-tooltip",
                            {
                              attrs: { top: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function(ref) {
                                      var on = ref.on
                                      return [
                                        _c(
                                          "v-icon",
                                          _vm._g(
                                            {
                                              staticClass: "mr-4",
                                              attrs: { color: "action" }
                                            },
                                            on
                                          ),
                                          [_vm._v(" mdi-airplane-takeoff ")]
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                1867364501
                              )
                            },
                            [_c("span", [_vm._v("Promotion is In Flight")])]
                          )
                        : _vm._e(),
                      _c("span", { staticClass: "text-body-2" }, [
                        _c("b", [_vm._v("Promotion Category:")]),
                        _vm._v(" " + _vm._s(_vm.promoTypeDisplayName) + " ")
                      ]),
                      _vm.promo.status
                        ? _c("span", { staticClass: "text-body-2 ml-4" }, [
                            _c("b", [_vm._v("Status:")]),
                            _vm._v(
                              " " + _vm._s(_vm.promo.status.status.name) + " "
                            )
                          ])
                        : _vm._e(),
                      _vm.promo.audit
                        ? [
                            _c("span", { staticClass: "ml-4 text-body-2" }, [
                              _c("b", [_vm._v("Last updated by:")]),
                              _vm._v(
                                " " + _vm._s(_vm.promo.audit.updated_by) + " "
                              )
                            ]),
                            _c("span", { staticClass: "ml-4 text-body-2" }, [
                              _c("b", [_vm._v("Created On:")]),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$config.formatDate(
                                      _vm.promo.audit.created_on
                                    )
                                  ) +
                                  " "
                              )
                            ]),
                            _c("span", { staticClass: "ml-4 text-body-2" }, [
                              _c("b", [_vm._v("Updated On:")]),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$config.formatDate(
                                      _vm.promo.audit.updated_on
                                    )
                                  ) +
                                  " "
                              )
                            ])
                          ]
                        : _vm._e(),
                      _vm.promo.cloned_from_promo_id
                        ? _c(
                            "span",
                            { staticClass: "ml-4 text-body-2" },
                            [
                              _c(
                                "router-link",
                                {
                                  staticClass: "primary--text",
                                  staticStyle: { "text-decoration": "none" },
                                  attrs: {
                                    to: {
                                      name: "Promo",
                                      query: {
                                        id: _vm.promo.cloned_from_promo_id
                                      }
                                    }
                                  }
                                },
                                [
                                  _vm._v(" Parent "),
                                  _c(
                                    "v-icon",
                                    { attrs: { small: "", color: "primary" } },
                                    [_vm._v("mdi-launch")]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "div",
                        { staticClass: "mt-4" },
                        [
                          _c("PromoHeader", {
                            ref: "promoTypeFields",
                            attrs: {
                              promo_type_constant: _vm.promo_type_constant,
                              promo: _vm.promo,
                              readOnlyPromo: _vm.readOnlyPromo,
                              showLumpSum: _vm.showLumpSum,
                              promoNameEditException:
                                _vm.promoNameEditException,
                              enabledInApprovedStatus:
                                _vm.enabledInApprovedStatus,
                              brand: _vm.brand,
                              description: _vm.description,
                              packageSize: _vm.packageSize,
                              netUnitCost: _vm.netUnitCost,
                              specialNote: _vm.specialNote
                            },
                            on: {
                              "update:brand": function($event) {
                                _vm.brand = $event
                              },
                              "update:description": function($event) {
                                _vm.description = $event
                              },
                              "update:packageSize": function($event) {
                                _vm.packageSize = $event
                              },
                              "update:package-size": function($event) {
                                _vm.packageSize = $event
                              },
                              "update:netUnitCost": function($event) {
                                _vm.netUnitCost = $event
                              },
                              "update:net-unit-cost": function($event) {
                                _vm.netUnitCost = $event
                              },
                              "update:specialNote": function($event) {
                                _vm.specialNote = $event
                              },
                              "update:special-note": function($event) {
                                _vm.specialNote = $event
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-form",
                        { ref: "form" },
                        [
                          _c(
                            "v-row",
                            { staticClass: "pt-4" },
                            [
                              _c(
                                "v-col",
                                {
                                  staticClass: "px-0 py-0",
                                  attrs: { cols: "4" }
                                },
                                [
                                  _c("PromoDates", {
                                    ref: "promoDates",
                                    attrs: {
                                      promo: _vm.promo,
                                      readOnlyPromo: _vm.readOnlyPromo
                                    },
                                    on: {
                                      resetBillingWeekStartDate:
                                        _vm.resetBillingWeekStartDate
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm.showAdDateField
                                ? _c(
                                    "v-col",
                                    { attrs: { cols: "2" } },
                                    [
                                      _c(
                                        "v-menu",
                                        {
                                          attrs: {
                                            transition: "scale-transition",
                                            "offset-y": "",
                                            "max-width": "290px",
                                            "min-width": "290px"
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "activator",
                                                fn: function(ref) {
                                                  var on = ref.on
                                                  var attrs = ref.attrs
                                                  return [
                                                    _c(
                                                      "v-text-field",
                                                      _vm._g(
                                                        _vm._b(
                                                          {
                                                            ref: "add_dt",
                                                            attrs: {
                                                              label: "Ad Date",
                                                              type: "date",
                                                              "prepend-inner-icon":
                                                                "mdi-calendar",
                                                              dense: "",
                                                              "background-color":
                                                                "#fff",
                                                              outlined: "",
                                                              clearable: !_vm.readOnlyPromo,
                                                              readonly:
                                                                _vm.readOnlyPromo,
                                                              rules: [
                                                                _vm.isValidAdDate
                                                              ]
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.promo
                                                                  .ad_date,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  _vm.promo,
                                                                  "ad_date",
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "promo.ad_date"
                                                            }
                                                          },
                                                          "v-text-field",
                                                          attrs,
                                                          false
                                                        ),
                                                        !_vm.readOnlyPromo
                                                          ? on
                                                          : null
                                                      )
                                                    )
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            false,
                                            956221358
                                          ),
                                          model: {
                                            value: _vm.ad_dt_picker,
                                            callback: function($$v) {
                                              _vm.ad_dt_picker = $$v
                                            },
                                            expression: "ad_dt_picker"
                                          }
                                        },
                                        [
                                          _c("v-date-picker", {
                                            attrs: {
                                              color: "action",
                                              "show-current":
                                                _vm.promo.start_dt || true,
                                              "no-title": ""
                                            },
                                            model: {
                                              value: _vm.promo.ad_date,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.promo,
                                                  "ad_date",
                                                  $$v
                                                )
                                              },
                                              expression: "promo.ad_date"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.promoIsAdCategory
                                ? _c(
                                    "v-col",
                                    { attrs: { cols: "2" } },
                                    [
                                      _c(
                                        "v-menu",
                                        {
                                          attrs: {
                                            transition: "scale-transition",
                                            "offset-y": "",
                                            "max-width": "290px",
                                            "min-width": "290px"
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "activator",
                                                fn: function(ref) {
                                                  var on = ref.on
                                                  var attrs = ref.attrs
                                                  return [
                                                    _c(
                                                      "v-text-field",
                                                      _vm._g(
                                                        _vm._b(
                                                          {
                                                            ref:
                                                              "offer_start_date ",
                                                            attrs: {
                                                              label:
                                                                "Perishable Offer Start Date",
                                                              type: "date",
                                                              "prepend-inner-icon":
                                                                "mdi-calendar",
                                                              dense: "",
                                                              "background-color":
                                                                "#fff",
                                                              outlined: "",
                                                              rules: [
                                                                _vm.isValidOfferStartDate
                                                              ],
                                                              clearable: !_vm.readOnlyPromo,
                                                              readonly:
                                                                _vm.readOnlyPromo
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.promo
                                                                  .offer_start_date,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  _vm.promo,
                                                                  "offer_start_date",
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "promo.offer_start_date "
                                                            }
                                                          },
                                                          "v-text-field",
                                                          attrs,
                                                          false
                                                        ),
                                                        !_vm.readOnlyPromo
                                                          ? on
                                                          : null
                                                      )
                                                    )
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            false,
                                            494976497
                                          ),
                                          model: {
                                            value: _vm.offer_start_dt_picker,
                                            callback: function($$v) {
                                              _vm.offer_start_dt_picker = $$v
                                            },
                                            expression: "offer_start_dt_picker"
                                          }
                                        },
                                        [
                                          _c("v-date-picker", {
                                            attrs: {
                                              color: "action",
                                              max:
                                                _vm.promo.offer_end_date ||
                                                null,
                                              "allowed-dates":
                                                _vm.allowedOfferStartDates,
                                              "no-title": ""
                                            },
                                            model: {
                                              value: _vm.promo.offer_start_date,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.promo,
                                                  "offer_start_date",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "promo.offer_start_date"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.promoIsAdCategory
                                ? _c(
                                    "v-col",
                                    { attrs: { cols: "2" } },
                                    [
                                      _c(
                                        "v-menu",
                                        {
                                          attrs: {
                                            transition: "scale-transition",
                                            "offset-y": "",
                                            "max-width": "290px",
                                            "min-width": "290px"
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "activator",
                                                fn: function(ref) {
                                                  var on = ref.on
                                                  var attrs = ref.attrs
                                                  return [
                                                    _c(
                                                      "v-text-field",
                                                      _vm._g(
                                                        _vm._b(
                                                          {
                                                            ref:
                                                              "offer_end_date",
                                                            attrs: {
                                                              label:
                                                                "Perishable Offer End Date",
                                                              type: "date",
                                                              "prepend-inner-icon":
                                                                "mdi-calendar",
                                                              dense: "",
                                                              "background-color":
                                                                "#fff",
                                                              outlined: "",
                                                              rules: [
                                                                _vm.isValidOfferEndDate
                                                              ],
                                                              clearable: !_vm.readOnlyPromo,
                                                              readonly:
                                                                _vm.readOnlyPromo
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.promo
                                                                  .offer_end_date,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  _vm.promo,
                                                                  "offer_end_date",
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "promo.offer_end_date"
                                                            }
                                                          },
                                                          "v-text-field",
                                                          attrs,
                                                          false
                                                        ),
                                                        !_vm.readOnlyPromo
                                                          ? on
                                                          : null
                                                      )
                                                    )
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            false,
                                            939966289
                                          ),
                                          model: {
                                            value: _vm.offer_end_dt_picker,
                                            callback: function($$v) {
                                              _vm.offer_end_dt_picker = $$v
                                            },
                                            expression: "offer_end_dt_picker"
                                          }
                                        },
                                        [
                                          _c("v-date-picker", {
                                            attrs: {
                                              min:
                                                _vm.promo.offer_start_date ||
                                                null,
                                              color: "action",
                                              "allowed-dates":
                                                _vm.allowedOfferEndDates,
                                              "no-title": ""
                                            },
                                            model: {
                                              value: _vm.promo.offer_end_date,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.promo,
                                                  "offer_end_date",
                                                  $$v
                                                )
                                              },
                                              expression: "promo.offer_end_date"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _c(
                                "v-col",
                                {
                                  staticClass: "px-1",
                                  attrs: { cols: _vm.promoIsAdCategory ? 2 : 4 }
                                },
                                [
                                  _c("v-select", {
                                    attrs: {
                                      label: "Promotion Type",
                                      "item-value": "id",
                                      "item-text": "name",
                                      "item-color": "action",
                                      items: _vm.billingModeOptions,
                                      "background-color": "#fff",
                                      rules: [_vm.isValidBillingMode],
                                      readonly: _vm.readOnlyPromo,
                                      dense: "",
                                      "hide-details": "auto",
                                      outlined: "",
                                      "return-object": ""
                                    },
                                    model: {
                                      value: _vm.promo.billing_mode,
                                      callback: function($$v) {
                                        _vm.$set(_vm.promo, "billing_mode", $$v)
                                      },
                                      expression: "promo.billing_mode"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                { staticClass: "px-1", attrs: { cols: "4" } },
                                [
                                  _c("PromoVendorSelect", {
                                    ref: "vendorSelect",
                                    attrs: {
                                      promoBillingParties:
                                        _vm.promoBillingParties,
                                      readOnlyPromo: _vm.readOnlyPromo,
                                      promo: _vm.promo
                                    },
                                    on: {
                                      queueChanges: _vm.queueBillingPartyChanges
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { staticClass: "px-1", attrs: { cols: "4" } },
                                [
                                  _c("PromoRelatedSubvendorSelect", {
                                    ref: "subvendorSelect",
                                    attrs: {
                                      promoBillingParties:
                                        _vm.promoBillingParties,
                                      promoSelectedSubvendors:
                                        _vm.promoSelectedSubvendors,
                                      readOnlyPromo: _vm.readOnlyPromo,
                                      billingPartiesBuffer:
                                        _vm.billingPartiesBuffer,
                                      allowMultipleSubvendors:
                                        _vm.allowMultipleSubvendors
                                    },
                                    on: {
                                      subvendorSelected:
                                        _vm.handleSubvendorSelected
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm.showVendorInvoiceAndInternalBillingParty
                                ? _c(
                                    "v-col",
                                    {
                                      staticClass: "px-1",
                                      attrs: { cols: "2" }
                                    },
                                    [
                                      _c("v-autocomplete", {
                                        attrs: {
                                          label: "Internal Billing Party",
                                          items: _vm.internalBillingParties,
                                          "item-text": "name",
                                          "item-value": "id",
                                          "item-color": "action",
                                          clearable: "",
                                          disabled:
                                            (_vm.promo.promo_category &&
                                              _vm.promo.promo_category.name ===
                                                "Ad Scan - ARG Spendback") ||
                                            !_vm.promo.vendor_invoice_exclude ||
                                            _vm.readOnlyPromo,
                                          rules: [
                                            _vm.internalBillingPartyRules
                                          ],
                                          "hide-details": "auto",
                                          "background-color": "#fff",
                                          dense: "",
                                          autocomplete: "off",
                                          outlined: "",
                                          "hide-no-data": ""
                                        },
                                        model: {
                                          value:
                                            _vm.promo.internal_billing_party_id,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.promo,
                                              "internal_billing_party_id",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "promo.internal_billing_party_id"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _c(
                                "v-col",
                                { attrs: { cols: "2" } },
                                [
                                  _c(
                                    "v-menu",
                                    {
                                      attrs: {
                                        transition: "scale-transition",
                                        "offset-y": "",
                                        "max-width": "290px",
                                        "min-width": "290px"
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function(ref) {
                                              var on = ref.on
                                              var attrs = ref.attrs
                                              return [
                                                _c(
                                                  "v-text-field",
                                                  _vm._g(
                                                    _vm._b(
                                                      {
                                                        ref: "billing_week",
                                                        attrs: {
                                                          label: "Billing Week",
                                                          type: "date",
                                                          "prepend-inner-icon":
                                                            "mdi-calendar",
                                                          dense: "",
                                                          "background-color":
                                                            "#fff",
                                                          outlined: "",
                                                          "hide-details":
                                                            "auto",
                                                          rules: [
                                                            _vm.billingWeekStartRules
                                                          ],
                                                          clearable: !_vm.readOnlyPromo,
                                                          disabled:
                                                            !_vm.promo
                                                              .manual_bill ||
                                                            !_vm.allowBillingEditing,
                                                          readonly:
                                                            _vm.promo
                                                              .manual_bill ||
                                                            _vm.readOnlyPromo
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.promo
                                                              .billing_week_start,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.promo,
                                                              "billing_week_start",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "promo.billing_week_start"
                                                        }
                                                      },
                                                      "v-text-field",
                                                      attrs,
                                                      false
                                                    ),
                                                    !_vm.readOnlyPromo
                                                      ? on
                                                      : null
                                                  )
                                                )
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        false,
                                        422452542
                                      ),
                                      model: {
                                        value: _vm.billing_week_dt_picker,
                                        callback: function($$v) {
                                          _vm.billing_week_dt_picker = $$v
                                        },
                                        expression: "billing_week_dt_picker"
                                      }
                                    },
                                    [
                                      _c("v-date-picker", {
                                        attrs: {
                                          color: "action",
                                          disabled: !_vm.promo.manual_bill,
                                          "allowed-dates":
                                            _vm.allowedBillingWeekDates,
                                          "no-title": ""
                                        },
                                        model: {
                                          value: _vm.promo.billing_week_start,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.promo,
                                              "billing_week_start",
                                              $$v
                                            )
                                          },
                                          expression: "promo.billing_week_start"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          !_vm.isVendorAccrualPromo
                            ? _c(
                                "v-row",
                                [
                                  !_vm.isAMAPorEBA
                                    ? _c(
                                        "v-col",
                                        {
                                          staticClass: "px-1",
                                          attrs: { cols: "4" }
                                        },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              label:
                                                "Missing Link Item Comments",
                                              disabled:
                                                _vm.enabledInApprovedStatus,
                                              dense: "",
                                              outlined: "",
                                              "hide-details": "auto",
                                              "background-color": "#fff"
                                            },
                                            model: {
                                              value: _vm.promo.comments,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.promo,
                                                  "comments",
                                                  $$v
                                                )
                                              },
                                              expression: "promo.comments"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm.showDigitalCoupon
                                    ? _c(
                                        "v-col",
                                        {
                                          staticClass: "px-1",
                                          attrs: { cols: "4" }
                                        },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              label: "ARG Digital Coupon Value",
                                              disabled:
                                                !_vm.promo.digital_coupon ||
                                                _vm.readOnlyPromo,
                                              dense: "",
                                              outlined: "",
                                              rules: [_vm.digitalCouponRules],
                                              "hide-details": "auto",
                                              "background-color": "#fff"
                                            },
                                            model: {
                                              value:
                                                _vm.promo.digital_coupon_note,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.promo,
                                                  "digital_coupon_note",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "promo.digital_coupon_note"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "v-row",
                            { staticClass: "mt-4", attrs: { align: "center" } },
                            [
                              _c(
                                "v-col",
                                { attrs: { cols: "2" } },
                                [
                                  !_vm.id
                                    ? _c("v-text-field", {
                                        attrs: {
                                          dense: "",
                                          outlined: "",
                                          "hide-details": "",
                                          "background-color": "#fff",
                                          label: "Promotion Number"
                                        },
                                        model: {
                                          value: _vm.promo.promo_number,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.promo,
                                              "promo_number",
                                              $$v
                                            )
                                          },
                                          expression: "promo.promo_number"
                                        }
                                      })
                                    : _c(
                                        "span",
                                        { staticClass: "text-body-2 my-auto" },
                                        [
                                          _c("b", [
                                            _vm._v("Promotion Number:")
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.promo.promo_number) +
                                              " "
                                          )
                                        ]
                                      )
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.showOverrides,
                                      expression: "showOverrides"
                                    }
                                  ],
                                  attrs: { cols: "auto" }
                                },
                                [
                                  _c(
                                    "v-layout",
                                    [
                                      _c("v-checkbox", {
                                        staticClass: "my-auto",
                                        attrs: {
                                          color: "checkbox",
                                          "hide-details": "",
                                          label: "Override Store Offset",
                                          disabled: _vm.readOnlyPromo
                                        },
                                        model: {
                                          value:
                                            _vm.promo.override_store_offset,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.promo,
                                              "override_store_offset",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "promo.override_store_offset"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.showOverrides,
                                      expression: "showOverrides"
                                    }
                                  ],
                                  attrs: { cols: "auto" }
                                },
                                [
                                  _c(
                                    "v-layout",
                                    [
                                      _c("v-checkbox", {
                                        staticClass: "my-auto",
                                        attrs: {
                                          color: "checkbox",
                                          "hide-details": "",
                                          label: "Override Store Ad Length",
                                          disabled: _vm.readOnlyPromo
                                        },
                                        model: {
                                          value:
                                            _vm.promo.override_store_length,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.promo,
                                              "override_store_length",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "promo.override_store_length"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        _vm.promo.promo_category &&
                                        _vm.promo.promo_category
                                          .scan_promotion &&
                                        !_vm.isVendorAccrualPromo,
                                      expression:
                                        "promo.promo_category && promo.promo_category.scan_promotion && !isVendorAccrualPromo"
                                    }
                                  ],
                                  attrs: { cols: "auto" }
                                },
                                [
                                  _c(
                                    "v-layout",
                                    [
                                      _c("v-checkbox", {
                                        staticClass: "my-auto",
                                        attrs: {
                                          color: "checkbox",
                                          "hide-details": "",
                                          label: "Enforce Compliance",
                                          disabled: ""
                                        },
                                        model: {
                                          value: _vm.promo.enforce_compliance,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.promo,
                                              "enforce_compliance",
                                              $$v
                                            )
                                          },
                                          expression: "promo.enforce_compliance"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: !_vm.isVendorAccrualPromo,
                                      expression: "!isVendorAccrualPromo"
                                    }
                                  ],
                                  attrs: { cols: "auto" }
                                },
                                [
                                  _c(
                                    "v-layout",
                                    [
                                      _c("v-checkbox", {
                                        staticClass: "my-auto",
                                        attrs: {
                                          color: "checkbox",
                                          "hide-details": "",
                                          label: "Perishable",
                                          disabled:
                                            _vm.readOnlyPromo ||
                                            _vm.isPCAF || _vm.promo.dsd
                                        },
                                        model: {
                                          value: _vm.promo.perishable,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.promo,
                                              "perishable",
                                              $$v
                                            )
                                          },
                                          expression: "promo.perishable"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm.showDigitalCoupon
                                ? _c(
                                    "v-col",
                                    { attrs: { cols: "auto" } },
                                    [
                                      _c(
                                        "v-layout",
                                        [
                                          _c("v-checkbox", {
                                            staticClass: "my-auto",
                                            attrs: {
                                              color: "checkbox",
                                              "hide-details": "",
                                              label: "ARG Digital Coupon",
                                              disabled: _vm.readOnlyPromo
                                            },
                                            model: {
                                              value: _vm.promo.digital_coupon,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.promo,
                                                  "digital_coupon",
                                                  $$v
                                                )
                                              },
                                              expression: "promo.digital_coupon"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.showVendorInvoiceAndInternalBillingParty
                                ? _c(
                                    "v-col",
                                    { attrs: { cols: "auto" } },
                                    [
                                      _c(
                                        "v-layout",
                                        [
                                          _c("v-checkbox", {
                                            staticClass: "my-auto",
                                            attrs: {
                                              color: "checkbox",
                                              "hide-details": "",
                                              label: "Vendor Invoice Exclude",
                                              disabled:
                                                (_vm.promo.promo_category &&
                                                  _vm.promo.promo_category
                                                    .name ===
                                                    "Ad Scan - ARG Spendback") ||
                                                _vm.readOnlyPromo
                                            },
                                            model: {
                                              value:
                                                _vm.promo
                                                  .vendor_invoice_exclude,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.promo,
                                                  "vendor_invoice_exclude",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "promo.vendor_invoice_exclude"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              !_vm.isAMAPorEBA
                                ? _c(
                                    "v-row",
                                    [
                                      _vm.isNonAllowancePromo &&
                                      !_vm.isVendorAccrualPromo
                                        ? _c(
                                            "v-col",
                                            { attrs: { cols: "auto" } },
                                            [
                                              _c(
                                                "v-layout",
                                                [
                                                  _c("v-checkbox", {
                                                    staticClass: "my-auto",
                                                    attrs: {
                                                      color: "checkbox",
                                                      label: "Private Label",
                                                      "hide-details": "",
                                                      disabled:
                                                        _vm.readOnlyPromo
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.promo.private_label,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.promo,
                                                          "private_label",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "promo.private_label"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm.showDSD
                                        ? _c(
                                            "v-col",
                                            { attrs: { cols: "auto" } },
                                            [
                                              _c(
                                                "v-layout",
                                                [
                                                  _c("v-checkbox", {
                                                    staticClass: "my-auto",
                                                    attrs: {
                                                      color: "checkbox",
                                                      label: "DSD",
                                                      "hide-details": "",
                                                      disabled:
                                                        _vm.readOnlyPromo ||
                                                        _vm.promoIsDSDOffInvoice ||
                                                          _vm.promo.perishable
                                                    },
                                                    model: {
                                                      value: _vm.promo.dsd,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.promo,
                                                          "dsd",
                                                          $$v
                                                        )
                                                      },
                                                      expression: "promo.dsd"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm.showSpecialAdLength
                                        ? _c(
                                            "v-col",
                                            { attrs: { cols: "auto" } },
                                            [
                                              _c(
                                                "v-layout",
                                                [
                                                  _c("v-checkbox", {
                                                    staticClass: "my-auto",
                                                    attrs: {
                                                      color: "checkbox",
                                                      "hide-details": "",
                                                      label:
                                                        "Special Ad Length",
                                                      disabled:
                                                        _vm.readOnlyPromo
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.promo
                                                          .special_ad_length,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.promo,
                                                          "special_ad_length",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "promo.special_ad_length"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "auto" } },
                                        [
                                          _c(
                                            "v-layout",
                                            [
                                              _c("v-checkbox", {
                                                staticClass: "my-auto",
                                                attrs: {
                                                  color: "checkbox",
                                                  "hide-details": "auto",
                                                  label: "Manual Invoice",
                                                  disabled:
                                                    _vm.readOnlyPromo ||
                                                    !_vm.allowBillingEditing
                                                },
                                                model: {
                                                  value: _vm.promo.manual_bill,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.promo,
                                                      "manual_bill",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "promo.manual_bill"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    2
                  )
                ])
              : _vm.tab === 1
              ? _c("storeTable", {
                  attrs: {
                    panel_height: _vm.panelHeight - 36.5,
                    promo: _vm.promo,
                    readOnlyPromo: _vm.readOnlyPromo,
                    partyItemSources: _vm.partyItemSources,
                    upstreamPartyIds: _vm.upstreamPartyIds,
                    showLumpSum: _vm.showLumpSum,
                    refreshStores: _vm.refreshStores,
                    promoAllowances: _vm.promoAllowances
                  },
                  on: {
                    enableItemsTab: function($event) {
                      _vm.itemsDisabled = false
                    },
                    setPromoPartyIds: _vm.setPromoPartyIds,
                    updateItemSources: _vm.updatePartyItemSources,
                    updateShuttleEnabled: function(val) {
                      return (_vm.shuttleEnabled = val)
                    },
                    setPromoAllowances: function(val) {
                      return (_vm.promoAllowances = val)
                    },
                    getPromoStores: _vm.getPromoStores,
                    addApprovedStatusNote: _vm.addApprovedStatusNote,
                    updateHistory: _vm.updatePromoHistory
                  }
                })
              : _c("itemTable", {
                  attrs: {
                    panel_height: _vm.panelHeight,
                    promo: _vm.promo,
                    readOnlyPromo: _vm.readOnlyPromo,
                    promo_type_constant: _vm.promo_type_constant,
                    item_sources: _vm.promoItemSources,
                    promoPartyIds: _vm.promoPartyIds,
                    vmc_sources: _vm.vmcSources,
                    vendorIds: _vm.vendorIds,
                    isPromoVendorAdmin: _vm.isPromoVendorAdmin
                  },
                  on: {
                    updatePromoItems: _vm.updatePromoItems,
                    updateHistory: _vm.updatePromoHistory,
                    updateTotalItems: function($event) {
                      _vm.totalItems = $event
                    }
                  }
                })
          ],
          1
        ),
        _c(
          "v-dialog",
          {
            attrs: { width: "500" },
            model: {
              value: _vm.confirmationModal,
              callback: function($$v) {
                _vm.confirmationModal = $$v
              },
              expression: "confirmationModal"
            }
          },
          [
            _c(
              "v-card",
              [
                _c("v-card-title", { staticClass: "headline grey lighten-2" }, [
                  _vm._v(" Are You Sure? ")
                ]),
                _c("v-card-text", [
                  _vm._v(
                    " Deleting a promo is a permanent action than cannot be undone. Are you sure you want to delete this promo? "
                  )
                ]),
                _c("v-divider"),
                _c(
                  "v-card-actions",
                  [
                    _c("v-spacer"),
                    _c(
                      "v-btn",
                      {
                        attrs: { color: "red darken-1 white--text" },
                        on: {
                          click: function($event) {
                            _vm.confirmationModal = false
                          }
                        }
                      },
                      [_vm._v(" No, don't delete! ")]
                    ),
                    _c(
                      "v-btn",
                      {
                        attrs: {
                          disabled: _vm.deleting,
                          loading: _vm.deleting,
                          color: "green darken-1 white--text"
                        },
                        on: {
                          click: function($event) {
                            return _vm.deletePromo()
                          }
                        }
                      },
                      [_vm._v(" Yes, I am sure! ")]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        ),
        _vm.showCloneModal
          ? _c("CloneModal", {
              attrs: {
                promo: _vm.promo,
                promoStores: _vm.promoStores,
                promoItemSources: _vm.promoItemSources,
                validSources: _vm.validSources,
                upstreamPartyIds: _vm.upstreamPartyIds,
                itemSourceRels: _vm.itemSourceRels
              },
              on: {
                success: _vm.initClonedPromo,
                cancel: function($event) {
                  _vm.showCloneModal = false
                }
              },
              model: {
                value: _vm.showCloneModal,
                callback: function($$v) {
                  _vm.showCloneModal = $$v
                },
                expression: "showCloneModal"
              }
            })
          : _vm._e(),
        _vm.showShuttleModal
          ? _c("ShuttleModal", {
              attrs: {
                promoPartyIds: _vm.promoPartyIds,
                partyItemSources: _vm.partyItemSources
              },
              on: {
                close: function($event) {
                  _vm.showShuttleModal = false
                }
              },
              model: {
                value: _vm.showShuttleModal,
                callback: function($$v) {
                  _vm.showShuttleModal = $$v
                },
                expression: "showShuttleModal"
              }
            })
          : _vm._e(),
        _vm.showStatusModal
          ? _c("StatusModal", {
              attrs: {
                promo: _vm.promo,
                promoItems: _vm.promoItems,
                promoPartyIds: _vm.promoPartyIds,
                loadingItems: _vm.loadingItems,
                vendorIds: _vm.vendorIds,
                validLumpSums: _vm.validLumpSums,
                lumpSumTotal: _vm.lumpSumTotal,
                validSubvendorSelected: _vm.validSubvendorSelected,
                validCategoryManagerSelected: _vm.validCategoryManagerSelected,
                isPromoStatusAdmin: _vm.isPromoStatusAdmin,
                readOnlyPromo: _vm.readOnlyPromo,
                promoChangesAreSaved: _vm.promoChangesAreSaved,
                totalItems: _vm.totalItems,
                promoAllowances: _vm.promoAllowances,
                promoStores: _vm.promoStores
              },
              on: {
                initPromoItems: _vm.initPromoItems,
                setPromoAllowances: function(val) {
                  return (_vm.promoAllowances = val)
                },
                refreshStores: function($event) {
                  _vm.refreshStores = true
                },
                close: function($event) {
                  _vm.showStatusModal = false
                },
                saved: _vm.statusSaved
              },
              model: {
                value: _vm.showStatusModal,
                callback: function($$v) {
                  _vm.showStatusModal = $$v
                },
                expression: "showStatusModal"
              }
            })
          : _vm._e(),
        _vm.vendorApprovalModal
          ? _c("VendorApprovalModal", {
              attrs: {
                promo: _vm.promo,
                promoBillingParties: _vm.promoBillingParties
              },
              on: {
                close: function($event) {
                  _vm.vendorApprovalModal = false
                },
                updateBillingParties: _vm.initBillingParties,
                autoSubmit: _vm.submitVendorApprovedPromo,
                updateHistory: _vm.updatePromoHistory
              },
              model: {
                value: _vm.vendorApprovalModal,
                callback: function($$v) {
                  _vm.vendorApprovalModal = $$v
                },
                expression: "vendorApprovalModal"
              }
            })
          : _vm._e(),
        _vm.complexMergingModal
          ? _c("ComplexMergingModal", {
              attrs: {
                promo: _vm.promo,
                promoParties: _vm.promoParties,
                isMergedPromo: _vm.isMergedPromo
              },
              on: {
                close: function($event) {
                  _vm.complexMergingModal = false
                },
                merged: _vm.goToPromo
              },
              model: {
                value: _vm.complexMergingModal,
                callback: function($$v) {
                  _vm.complexMergingModal = $$v
                },
                expression: "complexMergingModal"
              }
            })
          : _vm._e(),
        _vm.mergedPromosModal
          ? _c("MergedPromosModal", {
              attrs: { selectedPromo: _vm.promo },
              on: {
                close: function($event) {
                  _vm.mergedPromosModal = false
                }
              },
              model: {
                value: _vm.mergedPromosModal,
                callback: function($$v) {
                  _vm.mergedPromosModal = $$v
                },
                expression: "mergedPromosModal"
              }
            })
          : _vm._e(),
        _c(
          "v-dialog",
          {
            attrs: { persistent: "", width: "500" },
            model: {
              value: _vm.showChangeWarningModal,
              callback: function($$v) {
                _vm.showChangeWarningModal = $$v
              },
              expression: "showChangeWarningModal"
            }
          },
          [
            _c(
              "v-card",
              [
                _c("v-card-title", [_vm._v(" Promo Warnings ")]),
                _c("v-card-text", [
                  _vm._v(" Please confirm the following changes in "),
                  _c("strong", { staticClass: "black--text" }, [
                    _vm._v(_vm._s(_vm.promo.name))
                  ]),
                  _vm._v(" before proceeding: "),
                  _c(
                    "ul",
                    { staticClass: "red--text pl-4 ma-0" },
                    _vm._l(_vm.promoChangeWarnings, function(warning, index) {
                      return _c("li", {
                        key: index,
                        staticClass: "mb-2",
                        domProps: { innerHTML: _vm._s(warning) }
                      })
                    }),
                    0
                  )
                ]),
                _c(
                  "v-card-actions",
                  [
                    _c("v-spacer"),
                    _c(
                      "v-btn",
                      {
                        attrs: { color: "grey darken-1", text: "" },
                        on: { click: _vm.closeShowChangeWarningModal }
                      },
                      [_vm._v(" Cancel ")]
                    ),
                    _c(
                      "v-btn",
                      {
                        attrs: {
                          color: "primary",
                          disabled: _vm.saving,
                          loading: _vm.saving
                        },
                        on: { click: _vm.confirmSkipPromoChangeValidation }
                      },
                      [_vm._v(" Confirm ")]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }